export default class LayoutManager {

    LayoutManager() {
        this.scene = null;
    }
    updateAllLayoutProperties(game, layout) {
        if(layout === undefined) {
            console.warn(`Layout is undefined`);
            return;
        }
         //loop through all the layout properties and set them to the layout manager
         for (let key in layout) {
            const gameObject = game[key];
            if (gameObject === undefined) continue;
            this.updateProperties(gameObject, key, layout);
        }
    }

    updateProperties(gameObject, layoutName, layout) {

        if (!gameObject) {
            return;
        }

        //get Name of GameObject
        if (!layoutName && gameObject.name) {
            layoutName = gameObject.name;
        }
        
        if (!layout) {
            console.warn(`Could not find layout "${layoutName}" in layouts`, this.layouts);
            return;
        }

        //get layout properties
        const layoutProperties = layout[layoutName];
        if (!layoutProperties) {
            console.warn(`Could not find layout properties for "${layoutName}" in layout`, layout);
            return;
        }
       

        //update properties
        if (layoutProperties.scale != null){
            gameObject.scale.set(layoutProperties.scale);
            // this.cribbageBoard.scale.x = this.pileLayout["cribbageboard"].scale;
        }
        
        if (layoutProperties.x != null){
            gameObject.x = layoutProperties.x;
        }
        if (layoutProperties.y != null){
            gameObject.y = layoutProperties.y;
        }
        if (layoutProperties.width != null){
            gameObject.width = layoutProperties.width;
        }
        if (layoutProperties.height != null){
            gameObject.height = layoutProperties.height;
        }
        if (layoutProperties.r != null){
            let rotation = layoutProperties.r * (Math.PI / 180);
            gameObject.rotation = rotation;
        }
        if (layoutProperties.visible != null){
            gameObject.visible = layoutProperties.visible;
        }
        if (layoutProperties.alpha != null){
            gameObject.alpha = layoutProperties.alpha;
        }
        if (layoutProperties.orientation != null){
            gameObject.orientation = layoutProperties.orientation;
        }
        if (layoutProperties.zOrder != null){
            gameObject.zOrder = layoutProperties.zOrder;
        }

       


       
       
    }
}